import { Outlet } from "react-router-dom";
import CasaMapaAdminAnalyticsSubnav from "../../../components/casamapa/admin/CasaMapaAdminAnalyticsSubnav";
import { automapAdminPortalPath } from "../../../constants/automapAdminPortalPaths";
import { useAutoMapaCasaMapaAnalyticsView } from "../../../hooks/useAutoMapaCasaMapaAnalyticsView";
import { useLocale } from "../../../intl";
import "../../../styles/casamapaAdminPortal.css";

export default function AutoMapaAnalyticsLayout() {
  const { t } = useLocale();
  const { clientViewId, loading, error } = useAutoMapaCasaMapaAnalyticsView();
  const analyticsBase = automapAdminPortalPath("analytics");

  if (loading) {
    return <p className="muted panel-card">Loading analytics…</p>;
  }

  if (!clientViewId) {
    return (
      <div className="panel-card">
        <h2>{t("realEstate.casaMapa.admin.errors.noViewTitle")}</h2>
        <p className="muted">
          {error || t("realEstate.casaMapa.admin.errors.noViewMessage")}
        </p>
      </div>
    );
  }

  return (
    <div className="cm-admin-analytics automap-admin-analytics">
      <header className="cm-admin-analytics__hero panel-card">
        <div className="cm-admin-analytics__hero-copy">
          <p className="cm-admin-analytics__eyebrow">
            {t("realEstate.casaMapa.admin.analytics.eyebrow")}
          </p>
          <h1 className="cm-admin-analytics__title">
            {t("realEstate.casaMapa.admin.analytics.title")}
          </h1>
          <p className="cm-admin-analytics__lead">
            {t("realEstate.casaMapa.admin.analytics.subtitle")}
          </p>
        </div>
        <CasaMapaAdminAnalyticsSubnav basePath={analyticsBase} />
      </header>
      <Outlet
        context={{
          activeViewId: clientViewId,
          permissions: { viewAnalytics: true },
        }}
      />
    </div>
  );
}
